module.exports = __webpack_public_path__ + "img/icon_starB.dff41961.png";